<!-- ══════════════════════════════════════════════════════════════════════
     EXPANDED / FULL-SCREEN MODE — two-column layout with right sidebar
     ══════════════════════════════════════════════════════════════════════ -->
<ng-container *ngIf="isExpanded">

  <div class="aw-layout--expanded">

    <!-- ── LEFT: Main content ─────────────────────────────────────────── -->
    <div class="aw-main">

      <!-- Greeting -->
      <div class="aw-greeting">
        <h1>{{ greeting }}, {{ userName }} <span class="aw-wave">👋</span></h1>
        <p>How can I help you today?</p>
      </div>

      <!-- Large prominent input -->
      <form class="awx-input-wrap" (ngSubmit)="submit()">
        <textarea
          class="awx-textarea"
          [(ngModel)]="draft"
          name="queryExpanded"
          rows="3"
          placeholder="Ask anything about your security posture..."
          (keydown.enter)="submitFromKeyboard($event)"
        ></textarea>
        <div class="awx-input-bar">
          <div class="awx-pill-wrap">
            <button type="button" class="awx-agent-pill" [style.border-color]="activeAgent.color + '55'" (click)="toggleDropdown('input', $event)">
              <div class="aw-agent-icon awx-agent-icon-sm" [style.background]="activeAgent.color + '22'">
                <svg width="11" height="11" viewBox="0 0 24 24" fill="none" [attr.stroke]="activeAgent.color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path [attr.d]="getAgentSvg(activeAgent.icon)"/></svg>
              </div>
              <span [style.color]="activeAgent.color">{{ activeAgent.name }}</span>
              <svg width="10" height="10" viewBox="0 0 10 6" fill="none" [style.transform]="activeDropdown === 'input' ? 'rotate(180deg)' : ''"><path d="M1 1l4 4 4-4" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>
            </button>
            <div class="awx-dropdown" *ngIf="activeDropdown === 'input'" (click)="$event.stopPropagation()">
              <button
                *ngFor="let agent of agents"
                type="button"
                class="awx-dropdown-item"
                [class.awx-dropdown-item--active]="activeAgent.id === agent.id"
                (click)="selectAgent(agent)"
              >
                <div class="aw-agent-icon awx-agent-icon-sm" [style.background]="agent.color + '22'">
                  <svg width="11" height="11" viewBox="0 0 24 24" fill="none" [attr.stroke]="agent.color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path [attr.d]="getAgentSvg(agent.icon)"/></svg>
                </div>
                <div class="awx-dropdown-item-body">
                  <span class="awx-dropdown-item-name">{{ agent.name }}</span>
                  <span class="awx-dropdown-item-desc">{{ agent.description }}</span>
                </div>
                <svg *ngIf="activeAgent.id === agent.id" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
              </button>
            </div>
          </div>
          <span class="awx-hint">Shift + Enter for new line</span>
          <button type="submit" class="awx-send-btn" [disabled]="!draft.trim()" [style.background]="activeAgent.color">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="19" x2="12" y2="5"/><polyline points="5 12 12 5 19 12"/></svg>
          </button>
        </div>
      </form>

      <!-- Agents -->
      <div class="awx-section">
        <div class="awx-section-label">
          Available agents
          <!-- <button type="button" class="aw-view-all-link">View all →</button> -->
        </div>
        <div class="aw-agents-grid">
          <button
            *ngFor="let agent of agents"
            type="button"
            class="aw-agent-full-card"
            [class.aw-agent-full-card--active]="activeAgent.id === agent.id"
            (click)="selectAgent(agent)"
          >
            <div class="aw-agent-icon aw-agent-icon--md" [style.background]="agent.color + '22'">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" [attr.stroke]="agent.color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path [attr.d]="getAgentSvg(agent.icon)"/>
              </svg>
            </div>
            <div class="aw-agent-full-name">{{ agent.name }}</div>
            <div class="aw-agent-full-desc">{{ agent.description }}</div>
          </button>
        </div>
      </div>

      <!-- Suggested prompts — show first 3 only -->
      <div class="awx-section">
        <div class="awx-section-label">
          <div class="aw-agent-icon awx-agent-icon-sm" [style.background]="activeAgent.color + '22'">
            <svg width="11" height="11" viewBox="0 0 24 24" fill="none" [attr.stroke]="activeAgent.color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path [attr.d]="getAgentSvg(activeAgent.icon)"/></svg>
          </div>
          {{ activeAgent.name }} prompts
        </div>
        <ul class="aw-prompts-list">
          <li *ngFor="let prompt of activeAgent.prompts | slice:0:3">
            <button type="button" class="aw-prompt-item" (click)="submit(prompt)">
              <span class="aw-prompt-text">{{ prompt }}</span>
              <svg class="aw-prompt-arrow" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
            </button>
          </li>
        </ul>
      </div>

    </div>

    <!-- ── RIGHT: Sidebar panel ──────────────────────────────────────── -->
    <aside class="aw-right">

      <!-- Active agent -->
      <div class="aw-panel">
        <div class="aw-panel-title">Active agent</div>
        <div class="aw-active-agent">
          <div class="aw-agent-icon aw-agent-icon--md" [style.background]="activeAgent.color + '22'">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" [attr.stroke]="activeAgent.color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path [attr.d]="getAgentSvg(activeAgent.icon)"/>
            </svg>
          </div>
          <div class="aw-active-agent-info">
            <div class="aw-active-agent-name">{{ activeAgent.name }}</div>
            <div class="aw-active-status">
              <span class="aw-status-dot"></span> Active
            </div>
          </div>
          <div class="awx-pill-wrap awx-pill-wrap--right">
            <button type="button" class="aw-change-btn" (click)="toggleDropdown('change', $event)">Change</button>
            <div class="awx-dropdown awx-dropdown--right" *ngIf="activeDropdown === 'change'" (click)="$event.stopPropagation()">
              <button
                *ngFor="let agent of agents"
                type="button"
                class="awx-dropdown-item"
                [class.awx-dropdown-item--active]="activeAgent.id === agent.id"
                (click)="selectAgent(agent)"
              >
                <div class="aw-agent-icon awx-agent-icon-sm" [style.background]="agent.color + '22'">
                  <svg width="11" height="11" viewBox="0 0 24 24" fill="none" [attr.stroke]="agent.color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path [attr.d]="getAgentSvg(agent.icon)"/></svg>
                </div>
                <div class="awx-dropdown-item-body">
                  <span class="awx-dropdown-item-name">{{ agent.name }}</span>
                  <span class="awx-dropdown-item-desc">{{ agent.description }}</span>
                </div>
                <svg *ngIf="activeAgent.id === agent.id" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Recent chats -->
      <div class="aw-panel">
        <div class="aw-panel-header">
          <div class="aw-panel-title">Recent chats</div>
          <button type="button" class="aw-view-all-link">View all</button>
        </div>
        <ul class="aw-recent-list">
          <li *ngFor="let chat of recentChats" class="aw-recent-item">
            <div class="aw-recent-icon">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/></svg>
            </div>
            <div class="aw-recent-body">
              <div class="aw-recent-title-row">
                <span class="aw-recent-title">{{ chat.title }}</span>
                <span class="aw-recent-time">{{ chat.time }}</span>
              </div>
              <!-- <span class="aw-recent-preview">{{ chat.preview }}</span> -->
            </div>
            <button type="button" class="aw-recent-pin" title="Pin">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87L18.18 21 12 17.77 5.82 21 7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>
            </button>
          </li>
        </ul>
      </div>

      <!-- Browse agents promo -->
      <div class="aw-panel aw-promo-panel">
        <div class="aw-promo-body">
          <div class="aw-promo-text">
            <div class="aw-promo-title">Need a different agent?</div>
            <div class="aw-promo-sub">Explore all agents built for security operations.</div>
          </div>
          <div class="aw-promo-robot" aria-hidden="true">
            <img src="/assets/media/eva/eva-mini.png" alt="Octy" class="aw-promo-octy" />
          </div>
        </div>
        <button type="button" class="aw-browse-btn">Browse all agents →</button>
      </div>

    </aside>

  </div>

  <div class="aw-footer-note">AI can make mistakes. Verify important information.</div>

</ng-container>

<!-- ══════════════════════════════════════════════════════════════════════
     PANEL / SIDE-PANEL MODE — compact pills, no right sidebar
     ══════════════════════════════════════════════════════════════════════ -->
<ng-container *ngIf="!isExpanded">

  <div class="aw-layout">

    <div class="aw-main">

      <!-- Greeting -->
      <div class="aw-greeting">
        <h1>{{ greeting }}, {{ userName }} <span class="aw-wave">👋</span></h1>
        <p>How can I help you today?</p>
      </div>

      <!-- Large prominent input -->
      <form class="awx-input-wrap" (ngSubmit)="submit()">
        <textarea
          class="awx-textarea"
          [(ngModel)]="draft"
          name="queryPanel"
          rows="3"
          placeholder="Ask anything about your security posture..."
          (keydown.enter)="submitFromKeyboard($event)"
        ></textarea>
        <div class="awx-input-bar">
          <div class="awx-pill-wrap">
            <button type="button" class="awx-agent-pill" [style.border-color]="activeAgent.color + '55'" (click)="toggleDropdown('input', $event)">
              <div class="aw-agent-icon awx-agent-icon-sm" [style.background]="activeAgent.color + '22'">
                <svg width="11" height="11" viewBox="0 0 24 24" fill="none" [attr.stroke]="activeAgent.color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path [attr.d]="getAgentSvg(activeAgent.icon)"/></svg>
              </div>
              <span [style.color]="activeAgent.color">{{ activeAgent.name }}</span>
              <svg width="10" height="10" viewBox="0 0 10 6" fill="none" [style.transform]="activeDropdown === 'input' ? 'rotate(180deg)' : ''"><path d="M1 1l4 4 4-4" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>
            </button>
            <div class="awx-dropdown" *ngIf="activeDropdown === 'input'" (click)="$event.stopPropagation()">
              <button
                *ngFor="let agent of agents"
                type="button"
                class="awx-dropdown-item"
                [class.awx-dropdown-item--active]="activeAgent.id === agent.id"
                (click)="selectAgent(agent)"
              >
                <div class="aw-agent-icon awx-agent-icon-sm" [style.background]="agent.color + '22'">
                  <svg width="11" height="11" viewBox="0 0 24 24" fill="none" [attr.stroke]="agent.color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path [attr.d]="getAgentSvg(agent.icon)"/></svg>
                </div>
                <div class="awx-dropdown-item-body">
                  <span class="awx-dropdown-item-name">{{ agent.name }}</span>
                  <span class="awx-dropdown-item-desc">{{ agent.description }}</span>
                </div>
                <svg *ngIf="activeAgent.id === agent.id" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
              </button>
            </div>
          </div>
          <span class="awx-hint">Shift + Enter for new line</span>
          <button type="submit" class="awx-send-btn" [disabled]="!draft.trim()" [style.background]="activeAgent.color">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="19" x2="12" y2="5"/><polyline points="5 12 12 5 19 12"/></svg>
          </button>
        </div>
      </form>

      <!-- Agents — compact pill chips -->
      <div class="awx-section">
        <div class="awx-section-label">Available agents</div>
        <div class="aw-agents-row">
          <button
            *ngFor="let agent of agents"
            type="button"
            class="aw-agent-card"
            [class.aw-agent-card--active]="activeAgent.id === agent.id"
            (click)="selectAgent(agent)"
          >
            <div class="aw-agent-icon" [style.background]="agent.color + '22'">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" [attr.stroke]="agent.color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path [attr.d]="getAgentSvg(agent.icon)"/>
              </svg>
            </div>
            <span class="aw-agent-name">{{ agent.name }}</span>
          </button>
        </div>
      </div>

      <!-- Prompts — 3 max -->
      <div class="awx-section">
        <div class="awx-section-label">
          <div class="aw-agent-icon awx-agent-icon-sm" [style.background]="activeAgent.color + '22'">
            <svg width="11" height="11" viewBox="0 0 24 24" fill="none" [attr.stroke]="activeAgent.color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path [attr.d]="getAgentSvg(activeAgent.icon)"/></svg>
          </div>
          {{ activeAgent.name }} prompts
        </div>
        <ul class="aw-prompts-list">
          <li *ngFor="let prompt of activeAgent.prompts | slice:0:3">
            <button type="button" class="aw-prompt-item" (click)="submit(prompt)">
              <span class="aw-prompt-text">{{ prompt }}</span>
              <svg class="aw-prompt-arrow" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
            </button>
          </li>
        </ul>
      </div>

    </div>

  </div>

  <div class="aw-footer-note">AI can make mistakes. Verify important information.</div>

</ng-container>
